// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Uh2P","requiredAsterisk":"Info_requiredAsterisk__2BM1n"};